module.exports = __webpack_public_path__ + "static/img/huDongGif.e93b0b2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huDongGif.gif
// module id = xuTX
// module chunks = 2